export const settingsEndpoints = (builder) => ({    
    setMarketStatus: builder.mutation({
        query: (data) => ({url: `/settings/market-insight`, method: 'post', body: data}),
        invalidatesTags: ['settings'],
    }),
    getCronsHealthReport: builder.query({
        query: () => ({ url: `/settings/cron/admin/crons-health-report`, method: 'get' }),
        providesTags: ['settings'],
    }),
    getWebsiteHealth: builder.query({
        query: () => ({ url: `/settings/website-health`, method: 'get' }),
        providesTags: ['settings'],
    }),
    triggerPendingBvn: builder.mutation({
        query: () => ({ url: `/settings/pending-bvns`, method: 'patch' }),
        invalidatesTags: ['settings'],
    }),
})
